import React from 'react';
import type { GroupScore } from '../../types';

interface ScoreBoardProps {
  scores: GroupScore[];
  deltas?: Record<number, number>;
  compact?: boolean;
}

const MEDALS = ['🥇', '🥈', '🥉'];

export default function ScoreBoard({ scores, deltas, compact }: ScoreBoardProps) {
  if (scores.length === 0) return <p className="text-muted">Aucune équipe</p>;

  return (
    <div className="score-list">
      {scores.map((s) => {
        const delta = deltas?.[s.id];
        return (
          <div key={s.id ?? s.groupName} className={`score-row ${compact ? 'score-row-compact' : ''}`}>
            <span className="score-rank">{MEDALS[s.rank - 1] ?? s.rank}</span>
            <span className="score-dot" style={{ background: s.color || '#7c3aed' }} />
            <span className="score-name">{s.groupName}</span>
            <span className="score-pts">{s.totalPoints} pts</span>
            {delta !== undefined && delta > 0 && (
              <span className="score-delta score-delta-up">+{delta}</span>
            )}
            {delta !== undefined && delta === 0 && (
              <span className="score-delta score-delta-zero">—</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
